module.exports = __webpack_public_path__ + "e6244f9108464775d358c9fa3b733454.woff2";